var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// TODO: We shouldn't use a regular expression to validate email addresses
// because there is no good regular expression to validate RFC822.
// We could use a BNF parser like https://github.com/hapijs/isemail,
// but this is over complicated, the server should simply append `mailto:`
// to `external_url` when necessary
export default function isEmail(pattern) {
    return emailRegex.test(pattern);
}
